<template>
    <b-modal id="modal-rgpd" centered class="modal-rgpd">
      <div class="modal-rgpd-itens">
        <button
          class="modal-rgpd-itens-close"
          @click="$bvModal.hide('modal-rgpd')"
        >
        <img src="@/assets/img/close.png" alt="close" width="30">
        </button>
      </div>
      <div class="modal-rgpd-content">
        <h3>RGPD</h3>
        <div class="content-input-buttons">
            <div class="btn btn-forget">
                <button @click="$bvModal.show('modal-forget')">Quero ser esquecido</button>
            </div>
            <div class="btn btn-transfer-data">
                <button @click="$bvModal.show('modal-portability')">Transferir os meus dados</button>
            </div>
        </div>
      </div>
      <Forget/>
      <Portability/>
    </b-modal>
  </template>
  
  <script> 
  import Forget from './Forget.vue';
  import Portability from './Portability.vue';
  
  export default {
    components: {
        Forget,
        Portability
    }
  };
  </script>
  
  <style lang="scss">
  #modal-rgpd {
    .modal-header,
    .modal-footer {
      display: none;
    }
    .modal-dialog {
      max-width: 825px;
      margin: auto!important;;
      @media screen and (max-width: 991px) {
        max-width: 384px;
      }
    }
    .modal-content {
      border-radius: 0;
      border: 0;
      background-color: #F6F6F6!important;
    }
    .modal-body {
      height: 463px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      @media (max-width: 991px) {
        padding: 50px 20px;
        height: 463px;
      }
    }
  }
  .modal-rgpd {
    &-itens {
      display: flex;
      flex-direction: row-reverse;
      align-items: center;
      justify-content: space-between;
      &-close {
        position: absolute;
        right: -45px;
        top: -40px;
        width: 83px;
        height: 83px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: black;
        border: 1px solid black;
        border-radius: 50%;
        transition: 500ms;
        @media (max-width: 991px) {
          top: 20px;
          right: 20px;
          width: 40px;
          height: 40px;
          svg {
            max-width: 15px;
          }
        }
        &:hover,
        &:focus {
          opacity: 0.6;
        }
      }
    }
    &-content{
        max-height: 290px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-direction: column;
        gap: 24px;
    }
  }
.content-input-buttons{
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 20px;
    button{
        width: 280px;
        min-height: 56px;
        height: auto;
        border: none;
        background: rgb(254,206,9);
        background: linear-gradient(90deg, rgba(254,206,9,1) 0%, rgba(245,137,31,1) 100%);
        text-align: center;
        border-radius: 40px;
        padding: 10px 30px;
        font-size: 18px;
        font-family: "Font Regular";
        color: black;
        transition: 500ms;
        text-transform: uppercase;
    }
}
  </style>